import { Image } from 'antd';
import styled from 'styled-components';

export const StyledImage = styled(Image)`
    object-fit: ${({ $objectFit = 'contain' }) => $objectFit};
`;
